export default __webpack_public_path__ + "static/mobile_section3_feature2-fa914decad7a2ae5fffd158097519112.png";